import { Controller } from '@hotwired/stimulus';

// Picking an office adds its country to the accepted locations. Page-level on purpose:
// Ui::SelectFieldComponent knows nothing about offices, so the rule composes with it
// through the same `select-field-component:change` a real pick fires.
export default class extends Controller {
  static targets = ['list'];

  sync({ detail }) {
    if (!this.hasListTarget) return;

    const selected = this.selectedValues();

    (detail?.countries || [])
      .filter(name => !selected.includes(name))
      .forEach(name => {
        this.listTarget.dispatchEvent(
          new CustomEvent('select-field-component:change', {
            detail: { value: name, label: name },
            bubbles: true,
          })
        );
      });
  }

  selectedValues() {
    return Array.from(this.listTarget.querySelectorAll('input[type="hidden"]'), input => input.value);
  }
}
